import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FriendAndPartnerForm from '../../../components/forms/FriendAndPartnerForm';
import { useFriendAndPartnerById, useUpdateFriendAndPartner } from '../../../hooks/useFriendAndPartnerApi';
import { useNavigate, useParams } from 'react-router-dom';

const FriendAndPartnerEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useFriendAndPartnerById(id!);
  const updateFriendAndPartner = useUpdateFriendAndPartner();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Friend And Partners', href: '/admin/friendandpartners' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateFriendAndPartner.mutateAsync({ id: id!, data });
      navigate('/admin/friendandpartners');
    } catch (error) {
      console.error('Error updating FriendAndPartner:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/friendandpartners"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.FriendAndPartner.Edit'
    >
      {entityData ? (
        <FriendAndPartnerForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/friendandpartners')}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default FriendAndPartnerEdit;
